// Vue
import Vue from 'vue'

import '@js/config/plugins' // Misc JS plugins

// Vue plugins
import SvgIcon from '@js/vue/SvgIcon.vue'
import Popup from '@js/vue/Popup.vue'
import VModal from 'vue-js-modal' // https://github.com/euvl/vue-js-modal
import VTooltip from 'v-tooltip' // https://github.com/Akryum/v-tooltip
import PortalVue from 'portal-vue' // https://github.com/LinusBorg/portal-vue
import VueSimpleSpinner from 'vue-simple-spinner' // https://github.com/dzwillia/vue-simple-spinner
import VueJsonp from 'vue-jsonp'
import VueYouTubeEmbed from 'vue-youtube-embed'

Vue.use(VModal)
Vue.use(PortalVue)
Vue.use(VTooltip)
Vue.use(VueJsonp, 6000)
Vue.use(VueYouTubeEmbed)

// Global components
Vue.component('svg-icon', SvgIcon)
Vue.component('vue-simple-spinner', VueSimpleSpinner)
Vue.component('popup', Popup)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  delimiters: ['${', '}'],

  mounted() {
    window.lazySizes.init()
  },

  components: {
    'main-menu': () =>
      import(/* webpackChunkName: "basic" */ '@js/vue/MainMenu.vue'),
    toggle: () => import(/* webpackChunkName: "basic" */ '@js/vue/Toggle.vue'),
    'video-hero': () =>
      import(/* webpackChunkName: "video-hero" */ '@js/vue/VideoHero.vue'),
    'homepage-hero': () =>
      import(/* webpackChunkName: "homepage" */ '@js/vue/HomepageHero.vue'),
    'line-bg': () =>
      import(/* webpackChunkName: "basic" */ '@js/vue/LineBg.vue'),
    'entry-slider': () =>
      import(/* webpackChunkName: "entry-slider" */ '@js/vue/EntrySlider.vue'),
    'image-grid': () =>
      import(/* webpackChunkName: "events" */ '@js/vue/ImageGrid.vue'),
    'modal-with-cookie': () =>
      import(/* webpackChunkName: "events" */ '@js/vue/ModalWithCookie.vue'),
    'ownerrez-widget': () =>
      import(/* webpackChunkName: "ownerrez" */ '@js/vue/OwnerRezWidget.vue'),
  },

  methods: {
    pushDataLayer(data) {
      window.dl = window.dl || []
      window.dl.push(data)
    },
  },
})
